(function($, undefined) {
	'use strict';

	var scrollToTop = function() {
		$('html, body').animate({ scrollTop: 1 }, 'slow'); //1 because 0 doesn't work for some reason.
	};

	var init = function() {
		$('.js-go-back-to-top-btn').click(scrollToTop);
	};

	$(window).ready(function() {
		init();
	});
})(jQuery);
